import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from '../../../environments/environment.model';

/**
 * Parse environment variables including custom My Arable specific variables
 */
export const parseMyArableEnvironment = (config: Record<string, string>): Environment => {
  // Parse base AGR environment variables
  const baseEnvironment = parseAgrEnvironment(config);

  // Parse custom My Arable specific variables
  return {
    ...baseEnvironment,
    AZURE_MAPS_SUBSCRIPTION_KEY: config.AZURE_MAPS_SUBSCRIPTION_KEY || '',
    AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: config.AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY || '',
    FERTIGATION_DASHBOARD_WORKSPACE_ID: config.FERTIGATION_DASHBOARD_WORKSPACE_ID || '',
    FERTIGATION_DASHBOARD_REPORT_ID: config.FERTIGATION_DASHBOARD_REPORT_ID || '',
    VIRUS_DASHBOARD_WORKSPACE_ID: config.VIRUS_DASHBOARD_WORKSPACE_ID || '',
    VIRUS_DASHBOARD_REPORT_ID: config.VIRUS_DASHBOARD_REPORT_ID || '',
    TGA_POTATO_SEED_STARCH_DASHBOARD_WORKSPACE_ID: config.TGA_POTATO_SEED_STARCH_DASHBOARD_WORKSPACE_ID || '',
    TGA_POTATO_SEED_STARCH_DASHBOARD_REPORT_ID: config.TGA_POTATO_SEED_STARCH_DASHBOARD_REPORT_ID || '',
    TGA_ONION_DASHBOARD_WORKSPACE_ID: config.TGA_ONION_DASHBOARD_WORKSPACE_ID || '',
    TGA_ONION_DASHBOARD_REPORT_ID: config.TGA_ONION_DASHBOARD_REPORT_ID || '',
    TGA_GENERAL_INFORMATION_DASHBOARD_WORKSPACE_ID: config.TGA_GENERAL_INFORMATION_DASHBOARD_WORKSPACE_ID || '',
    TGA_GENERAL_INFORMATION_DASHBOARD_REPORT_ID: config.TGA_GENERAL_INFORMATION_DASHBOARD_REPORT_ID || '',
    TGA_FERTILIZER_DASHBOARD_WORKSPACE_ID: config.TGA_FERTILIZER_DASHBOARD_WORKSPACE_ID || '',
    TGA_FERTILIZER_DASHBOARD_REPORT_ID: config.TGA_FERTILIZER_DASHBOARD_REPORT_ID || '',
    TGA_PHYTOPHTHORA_DASHBOARD_WORKSPACE_ID: config.TGA_PHYTOPHTHORA_DASHBOARD_WORKSPACE_ID || '',
    TGA_PHYTOPHTHORA_DASHBOARD_REPORT_ID: config.TGA_PHYTOPHTHORA_DASHBOARD_REPORT_ID || '',
    TGA_VELDWAARNEMINGEN_DASHBOARD_WORKSPACE_ID: config.TGA_VELDWAARNEMINGEN_DASHBOARD_WORKSPACE_ID || '',
    TGA_VELDWAARNEMINGEN_DASHBOARD_REPORT_ID: config.TGA_VELDWAARNEMINGEN_DASHBOARD_REPORT_ID || '',
    SHOW_DOWNY_MILDEW_DASHBOARD_WIDGET: config.SHOW_DOWNY_MILDEW_DASHBOARD_WIDGET === 'true',
    SHOW_VIRUS_MONITOR_DASHBOARD_WIDGET: config.SHOW_VIRUS_MONITOR_DASHBOARD_WIDGET === 'true',
    SHOW_SYNC_FROM_EXTERNAL_FARM_PROVIDER_BUTTON: config.SHOW_SYNC_FROM_EXTERNAL_FARM_PROVIDER_BUTTON === 'true',
    PRE_SALES_REBUILD_DONE: config.PRE_SALES_REBUILD_DONE === 'true',
  };
};
